// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bo7g","label":"styles_label__Rs9S0"};